
import KeyMirror from "keymirror";
export const ActionTypes = KeyMirror({
  SET_SCHEDULE_TEMPLATES: null,
});

export interface IScheduleTemplatesState {
  scheduleTemplates: ScheduleTemplate[];
}
